import { useApolloClient } from '@apollo/react-hooks';
import React from 'react';

import { logout } from './logout';

export const useLogout = () => {
  const client = useApolloClient();

  return React.useCallback(async (noReload?: boolean) => {
    await client.clearStore();
    await logout(noReload);
  }, [ client ]);
};
